var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"py-9",attrs:{"dark":""}},[_c('v-container',{staticClass:"text-center pa-0"},[_vm._v(" COPYRIGHT © "+_vm._s(_vm.thisYear)+" KODSC ALL RIGHTS RESERVED. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }